import React from 'react'

export default function Garbage({ className }) {
  return (
    <svg
      className={`${className} w-8 h-8`}
      xmlns="http://www.w3.org/2000/svg"
      fill="#59bdff"
      viewBox="0 0 24 24"
    >
      <path d="M9 3V4H4V6H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z" />
    </svg>
  );
}

